import type { CompetitorProps } from '@/components/Competitors/Competitor';
import { useSelector, shallowEqual } from 'react-redux';
import {
  getSummary,
  getFirst3Competitors,
} from '@/pages/CompanyReport/redux/selectors';

interface CompanySummaryState {
  isFund: boolean;
  companyId: string;
  competitors: CompetitorProps[];
  shortDescription: string;
  description: string;
  companyName: string;
  uniqueSymbol: string;
  tickerSymbol: string;
  snowflakePoints: number[];
  fundamentalsSentence?: string;
}

export const useCompanySummaryState = (
  companyId?: string
): CompanySummaryState => {
  const summaryState = useSelector<any, CompanySummaryState>((state) => {
    const ownProps = { companyId };
    const summary = getSummary(state, ownProps);
    const competitors = getFirst3Competitors(state, ownProps);

    return {
      isFund: summary.isFund,
      companyId: companyId as string,
      shortDescription: summary.shortDescription,
      description: summary.description,
      companyName: summary.shortName,
      tickerSymbol: summary.tickerSymbol,
      competitors,
      uniqueSymbol: summary.uniqueSymbol,
      snowflakePoints: summary.snowflakePoints,
      fundamentalsSentence: summary.fundamentals,
    };
  }, shallowEqual);

  return summaryState;
};
